export default __webpack_public_path__ + "static/media/startBackdrop.c8a58949.jpg";